import Http from "./http";

export const getAllStatesAPI = (data) => {
    return Http.post("api/states", data);
};
